module.exports = __webpack_public_path__ + "view/img/TwoDimensionalCode.9a0934b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TwoDimensionalCode.jpg
// module id = 94Fp
// module chunks = 13